import React from "react";
import { STATE_CODES } from "../../../../constants/branch.constants";

const BranchAddressInfo = ({ formData, updateField, errors }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address Line 1 *
          </label>
          <input
            type="text"
            value={formData.address.line1}
            onChange={(e) => updateField("address", "line1", e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg ${
              errors.line1 ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.line1 && (
            <p className="text-red-500 text-xs mt-1">{errors.line1}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address Line 2
          </label>
          <input
            type="text"
            value={formData.address.line2}
            onChange={(e) => updateField("address", "line2", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              City *
            </label>
            <input
              type="text"
              value={formData.address.city}
              onChange={(e) => updateField("address", "city", e.target.value)}
              className={`w-full px-3 py-2 border rounded-lg ${
                errors.city ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.city && (
              <p className="text-red-500 text-xs mt-1">{errors.city}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              State *
            </label>
            <select
              value={formData.address.state}
              onChange={(e) => updateField("address", "state", e.target.value)}
              className={`w-full px-3 py-2 border rounded-lg ${
                errors.state ? "border-red-500" : "border-gray-300"
              }`}
            >
              <option value="">Select State</option>
              {Object.entries(STATE_CODES).map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </select>
            {errors.state && (
              <p className="text-red-500 text-xs mt-1">{errors.state}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              PIN Code *
            </label>
            <input
              type="text"
              value={formData.address.pinCode}
              onChange={(e) =>
                updateField("address", "pinCode", e.target.value)
              }
              maxLength="6"
              className={`w-full px-3 py-2 border rounded-lg ${
                errors.pinCode ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.pinCode && (
              <p className="text-red-500 text-xs mt-1">{errors.pinCode}</p>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Landmark
          </label>
          <input
            type="text"
            value={formData.address.landmark}
            onChange={(e) => updateField("address", "landmark", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Latitude
            </label>
            <input
              type="number"
              step="any"
              value={formData.address.latitude}
              onChange={(e) =>
                updateField("address", "latitude", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              placeholder="19.0760"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Longitude
            </label>
            <input
              type="number"
              step="any"
              value={formData.address.longitude}
              onChange={(e) =>
                updateField("address", "longitude", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              placeholder="72.8777"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Google Maps URL
            </label>
            <input
              type="url"
              value={formData.address.googleMapsUrl}
              onChange={(e) =>
                updateField("address", "googleMapsUrl", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              placeholder="https://maps.google.com/..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchAddressInfo;
